var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepliant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 80,
    viewBox: "0 0 144 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.927 8.63013C143.747 10.0901 143.278 11.52 142.418 12.7C142.088 13.15 141.988 13.2502 141.608 13.6602L77.6075 77.6602C76.1875 78.9602 75.8275 79.0501 75.0075 79.3901C72.1075 80.5901 68.6174 79.8102 66.2874 77.6602L2.28745 13.6602C0.897445 12.1502 0.697494 11.56 0.337494 10.47C-1.19251 5.75997 2.67748 0 7.94748 0C10.0475 0 12.0475 0.910088 13.6075 2.34009L71.9475 60.6899L130.288 2.34009C130.288 2.34009 134.867 -1.10989 139.007 0.610107C141.517 1.65011 143.428 4.05 143.848 6.75C144.038 7.94 143.937 8.24013 143.927 8.63013Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepliant);
export default __webpack_public_path__ + "static/media/depliant.92428636f4fa5ebbf0956a11ac68eb80.svg";
export { ForwardRef as ReactComponent };